var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "tab-vessel-eq", attrs: { id: "tabVesselEq" } },
        [
          _c("div", { staticStyle: { width: "fit-content" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "85px",
                        "label-position": "right",
                        disabled: !_vm.isEdit
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))
                          ]),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "warn-label",
                              attrs: { label: _vm.$t("SeaExport.FlightNo") }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "6", disabled: "" },
                                model: {
                                  value: _vm.form.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "voyageFlight", $$v)
                                  },
                                  expression: "form.voyageFlight"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.MasterBillNo") }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "row",
                                    "padding-right": "3px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isInputMbl,
                                        expression: "isInputMbl"
                                      }
                                    ],
                                    class:
                                      _vm.form.mbl === "CANCELLED"
                                        ? "mbl-red"
                                        : "",
                                    attrs: { no: "7", disabled: "" },
                                    model: {
                                      value: _vm.form.mbl,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "mbl", $$v)
                                      },
                                      expression: "form.mbl"
                                    }
                                  }),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.isInputMbl,
                                        expression: "!isInputMbl"
                                      }
                                    ],
                                    class:
                                      _vm.form.mbl === "CANCELLED"
                                        ? "mbl-red"
                                        : "",
                                    attrs: { no: "8", disabled: "" },
                                    on: {
                                      input: function($event) {
                                        _vm.mblConfig.curRule = null
                                      }
                                    },
                                    model: {
                                      value: _vm.form.mbl,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "mbl", $$v)
                                      },
                                      expression: "form.mbl"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showButton,
                                          expression: "showButton"
                                        }
                                      ],
                                      staticClass:
                                        "el-button el-button--primary el-button--mini",
                                      staticStyle: {
                                        "min-width": "40px!important",
                                        "margin-left": "2px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.pm.showMBLDetailBtnClickHandler()
                                        }
                                      }
                                    },
                                    [_vm._v("⊙")]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.SoNo") } },
                            [
                              _c("so-no-input", {
                                attrs: { no: "27", disabled: !_vm.isEdit },
                                model: {
                                  value: _vm.form.jobSoNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "jobSoNo", $$v)
                                  },
                                  expression: "form.jobSoNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "warn-label",
                              attrs: { label: _vm.$t("SeaExport.BookingDate") }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "bookingDate",
                                  disabled: !_vm.isEdit,
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss"
                                },
                                model: {
                                  value: _vm.form.bookingDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "bookingDate", $$v)
                                  },
                                  expression: "form.bookingDate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.BookingNo") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: !_vm.isEdit, no: "9" },
                                model: {
                                  value: _vm.form.bookingNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "bookingNo", $$v)
                                  },
                                  expression: "form.bookingNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.quotationNum") }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: !_vm.isEdit, no: "12" },
                                model: {
                                  value: _vm.form.quotationNum,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "quotationNum", $$v)
                                  },
                                  expression: "form.quotationNum"
                                }
                              })
                            ],
                            1
                          ),
                          _c("br"),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.MultiJourneyAirline"))
                            )
                          ]),
                          _c(
                            "dev",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "80px"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.isEdit ||
                                        _vm.exportToImportEnableEdit,
                                      expression:
                                        "isEdit || exportToImportEnableEdit"
                                    }
                                  ],
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.addAirline }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SystemMaintenance.Add"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.isEdit ||
                                        _vm.exportToImportEnableEdit,
                                      expression:
                                        "isEdit || exportToImportEnableEdit"
                                    }
                                  ],
                                  attrs: {
                                    disabled: !_vm.clickedAirline,
                                    size: "mini",
                                    type: "primary"
                                  },
                                  on: { click: _vm.deleteAirline }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SystemMaintenance.Delete"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "grid-options": _vm.gridOptions,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData,
                              "show-side-bar": false
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.gridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: !_vm.isEdit,
                        "label-width": "150px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "title" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.PolAirPortInfo")) + " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("SeaExport.PolPortInfoPrompt"),
                                placement: "top-start"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Airport") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "19",
                              disabled: Boolean(_vm.form.lclMasterUuid)
                            },
                            model: {
                              value: _vm.form.airport,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "airport", $$v)
                              },
                              expression: "form.airport"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualEntryTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualEntryTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "20",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualEntryTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualEntryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualEntryTime", $$v)
                              },
                              expression: "form.actualEntryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualLoadingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualLoadingTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "21",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualLoadingTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualLoadingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualLoadingTime", $$v)
                              },
                              expression: "form.actualLoadingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_EstimatedDepartureTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedDepartureTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "22",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedDepartureTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedDepartureTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedDepartureTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedDepartureTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualDepartureTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualDepartureTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "23",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualDepartureTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualDepartureTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualDepartureTime", $$v)
                              },
                              expression: "form.actualDepartureTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.PodAirPortInfo")))
                      ]),
                      _c(
                        "span",
                        { staticStyle: { "font-weight": "lighter" } },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.LocalTime")))]
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EstimatedArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedArrivalTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedPortDischargeTime",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedArrivalTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedArrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estimatedArrivalTime", $$v)
                              },
                              expression: "form.estimatedArrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualArrivalTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "34",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualArrivalTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualArrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualArrivalTime", $$v)
                              },
                              expression: "form.actualArrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualBillingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualReceivingTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualReceivingTime",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualReceivingTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualReceivingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualReceivingTime", $$v)
                              },
                              expression: "form.actualReceivingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualUnloadingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualUnloadingTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "35",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualUnloadingTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualUnloadingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualUnloadingTime", $$v)
                              },
                              expression: "form.actualUnloadingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_ActualArrivalNotificationTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualArrivalNotificationTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualArrivalNotificationTime",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualArrivalNotificationTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualArrivalNotificationTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "actualArrivalNotificationTime",
                                  $$v
                                )
                              },
                              expression: "form.actualArrivalNotificationTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ActualPickupTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualPickupTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "36",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualPickupTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualPickupTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualPickupTime", $$v)
                              },
                              expression: "form.actualPickupTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: !_vm.isEdit,
                        "label-width": "110px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.PODDeliveryInformation"))
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.DeliveryToWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.EstimatedDeliveryToWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedWarehouseDeliveryTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "41",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedWarehouseDeliveryTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedWarehouseDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedWarehouseDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedWarehouseDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.DeliveryToWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.ActualDeliveryToWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualWarehouseDeliveryTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "42",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualWarehouseDeliveryTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualWarehouseDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "actualWarehouseDeliveryTime",
                                  $$v
                                )
                              },
                              expression: "form.actualWarehouseDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedShippingTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "43",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedShippingTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedShippingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "estimatedShippingTime", $$v)
                              },
                              expression: "form.estimatedShippingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            title: _vm.$t(
                              "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                            ),
                            label: _vm.$t(
                              "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualShippingTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "44",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualShippingTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualShippingTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualShippingTime", $$v)
                              },
                              expression: "form.actualShippingTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("AirExport.EstimatedArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedTimeOfDelivery",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "32",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedTimeOfDelivery",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedTimeOfDelivery,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedTimeOfDelivery",
                                  $$v
                                )
                              },
                              expression: "form.estimatedTimeOfDelivery"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showButton,
                              expression: "showButton"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("AirExport.ActualArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "actualDeliveryTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "33",
                              type: "datetime",
                              disabled: Boolean(_vm.form.lclMasterUuid),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "actualDeliveryTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.actualDeliveryTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "actualDeliveryTime", $$v)
                              },
                              expression: "form.actualDeliveryTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.EquipmentReceiptAddress")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", rows: 3, no: "49" },
                            model: {
                              value: _vm.form.shippingAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shippingAddress", $$v)
                              },
                              expression: "form.shippingAddress"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EquipmentReceiptContactPerson"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "50" },
                            model: {
                              value: _vm.form.shippingContactPerson,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shippingContactPerson", $$v)
                              },
                              expression: "form.shippingContactPerson"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.EquipmentReceiptContactWay"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "51" },
                            model: {
                              value: _vm.form.shippingContactInfo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shippingContactInfo", $$v)
                              },
                              expression: "form.shippingContactInfo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                        [
                          _c("el-date-picker", {
                            ref: "fileCutoff",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "52",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "fileCutoff",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.fileCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "fileCutoff", $$v)
                              },
                              expression: "form.fileCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerClosingTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "customerFileCutoff",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "56",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "customerFileCutoff",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customerFileCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerFileCutoff", $$v)
                              },
                              expression: "form.customerFileCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                        [
                          _c("el-date-picker", {
                            ref: "customCutoff",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "54",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "customCutoff",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customCutoff", $$v)
                              },
                              expression: "form.customCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerCyCutOffDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "customerCutoff",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "55",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "customerCutoff",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customerCutoff,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerCutoff", $$v)
                              },
                              expression: "form.customerCutoff"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomerShutOutDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "customerShutout",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "56",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "customerShutout",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.customerShutout,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerShutout", $$v)
                              },
                              expression: "form.customerShutout"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.remarks") } },
                        [
                          _c("el-input", {
                            attrs: { no: "66" },
                            model: {
                              value: _vm.form.customerRemark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customerRemark", $$v)
                              },
                              expression: "form.customerRemark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-card",
                      staticStyle: { height: "100%" },
                      attrs: {
                        disabled: !_vm.isEdit,
                        "label-width": "130px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.AirSecondVesselInfo")))
                      ]),
                      _c(
                        "span",
                        { staticStyle: { "font-weight": "lighter" } },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.LocalTime")))]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("Message.IntermediateAirline"),
                            placement: "right-end"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning red",
                            staticStyle: { cursor: "pointer" }
                          })
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: { label: _vm.$t("SeaExport.FlightNo") }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", no: "64" },
                            model: {
                              value: _vm.form.secondFlight,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondFlight", $$v)
                              },
                              expression: "form.secondFlight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SecondPolCode")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondPolCode",
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "secondPolCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              filterable: "",
                              "default-value": _vm.form.secondPolCode,
                              "tag-name": "code"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.secondPolCode = p.value
                                _vm.form.secondPol = p.englishName
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: { label: _vm.$t("CargoMsg.Cargo_SecondPol") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "secondPol" },
                            model: {
                              value: _vm.form.secondPol,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPol", $$v)
                              },
                              expression: "form.secondPol"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_SecondPodCode")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            ref: "secondPodCode",
                            staticStyle: { flex: "1" },
                            attrs: {
                              disabled: "",
                              no: "secondPodCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              filterable: "",
                              "default-value": _vm.form.secondPodCode,
                              "tag-name": "code"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: { label: _vm.$t("CargoMsg.Cargo_SecondPod") }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "", no: "secondPod" },
                            model: {
                              value: _vm.form.secondPod,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "secondPod", $$v)
                              },
                              expression: "form.secondPod"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_EstimatedTransitArrivalTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedTransferArrivalTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedTransferArrivalTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedTransferArrivalTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedTransferArrivalTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedTransferArrivalTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedTransferArrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TransitArrivalTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "transferArrivalTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "transferArrivalTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "transferArrivalTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.transferArrivalTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transferArrivalTime", $$v)
                              },
                              expression: "form.transferArrivalTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_EstimatedTransitDepartureTime"
                            )
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "estimatedTransferDepartureTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedTransferDepartureTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "estimatedTransferDepartureTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.estimatedTransferDepartureTime,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "estimatedTransferDepartureTime",
                                  $$v
                                )
                              },
                              expression: "form.estimatedTransferDepartureTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "warn-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TransitDepartureTime")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            ref: "transferDepartureTime",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "transferDepartureTime",
                              type: "date",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm:ss"
                            },
                            on: {
                              blur: function() {
                                _vm.handleBlur(
                                  "transferDepartureTime",
                                  null,
                                  true,
                                  true,
                                  _vm.form
                                )
                              }
                            },
                            model: {
                              value: _vm.form.transferDepartureTime,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "transferDepartureTime", $$v)
                              },
                              expression: "form.transferDepartureTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c("generate-mbl-no-dialog", {
            attrs: {
              visible: _vm.mblConfig.visible,
              form: _vm.form,
              config: _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.mblConfig.visible = false
              }
            }
          }),
          _c("generate-so-no-dialog", {
            attrs: {
              visible: _vm.soNoConfig.visible,
              form: _vm.form,
              config: _vm.soNoConfig,
              "mbl-config": _vm.mblConfig
            },
            on: {
              close: function($event) {
                _vm.soNoConfig.visible = false
              }
            }
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("Message.WarmReminder"),
                visible: _vm.prompt.dialogVisible,
                width: "30%",
                "show-close": false,
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.prompt, "dialogVisible", $event)
                }
              }
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.prompt.message1))]),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm.prompt.message2))]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                    [_vm._v(_vm._s(_vm.$t("Message.Determine")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }